export const environment = {
  URL_API: 'https://dastock-dev-api.disrosoft.com/api/',
  production: false
};
